import { render, staticRenderFns } from "./PersonnelEfficiencyStats.vue?vue&type=template&id=51ba6d63&scoped=true"
import script from "./PersonnelEfficiencyStats.vue?vue&type=script&lang=js"
export * from "./PersonnelEfficiencyStats.vue?vue&type=script&lang=js"
import style0 from "./PersonnelEfficiencyStats.vue?vue&type=style&index=0&id=51ba6d63&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba6d63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ba6d63')) {
      api.createRecord('51ba6d63', component.options)
    } else {
      api.reload('51ba6d63', component.options)
    }
    module.hot.accept("./PersonnelEfficiencyStats.vue?vue&type=template&id=51ba6d63&scoped=true", function () {
      api.rerender('51ba6d63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/kanbanPlatform/endKanbanBoard/components/PersonnelEfficiencyStats.vue"
export default component.exports